import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, List } from 'antd';
import { handleListTaxiCompanies, handleLoadUserSelectedtaxiCompany, handleUserSelectedCompany } from "./handler";
import { useNavigate } from "react-router-dom";
const { Option } = Select;

const TaxiCompanyComponent = (props) => {
    const [visible, setVisible] = useState(false);
    const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  
    const showDrawer = () => {
      setVisible(true);
    };
  
    const onClose = () => {
      setVisible(false);
      props.setShowTaxiCompany(false)
    };
    const navigate = useNavigate();

    const [listTaxiCompanies, setListTaxiCompanies] = useState([])
    const [selectedTaxiCompany, setSelectedTaxiCompany] = useState("")
    useEffect(() => {
      if (props.showTaxiCompany) {
        setVisible(props.showTaxiCompany)
        handleListTaxiCompanies(setListTaxiCompanies)
        handleLoadUserSelectedtaxiCompany(props.selectedItemIndex, props.memberRequirement.requiredDocuments, setSelectedTaxiCompany)
      }
    }, [props.showTaxiCompany])
  
    return (
      <div>
        <Drawer
        className='taxi-company'
          title="Select Options"
          placement="bottom"
          onClose={onClose}
          open={visible}
          width={300}
        >
          {/* {
          <Select defaultValue={selectedTaxiCompany} style={{ width: '100%' }} onChange={(e)=>{
            setSelectedTaxiCompany(e)
            handleUserSelectedCompany(e, token, selectedProfileType.profileId, props.memberRequirement,props.setMemberRequirement, props.selectedItemIndex, navigate, setVisible, props.setShowTaxiCompany)
          }}>
            
            {
                listTaxiCompanies.length > 0 && listTaxiCompanies.map((t) => {
                    return <Option value={t}>{t}</Option>
                })
            }
          </Select>} */}
        <List
          dataSource={listTaxiCompanies}
          renderItem={(item) => (
            <List.Item key={item} onClick={() => { 
              setSelectedTaxiCompany(item); 
              handleUserSelectedCompany(item, selectedProfileType.profileId, props.memberRequirement,props.setMemberRequirement, props.selectedItemIndex, navigate, setVisible, props.setShowTaxiCompany,props.setShowSaveButton);
            }}>
              { selectedTaxiCompany === item ? <div><b>{item}</b></div> : <div>{item}</div> }
            </List.Item>
          )}
        />

        
        </Drawer>
      </div>
    );
};

export default TaxiCompanyComponent;
  